import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import { CheckCircle, XCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface StripePageProps {
  operationtype: string;
}

export default function StripePage({ operationtype }: StripePageProps) {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate()

  useEffect(() => {
    if (operationtype === "success") {
      navigate("/dashboard/campaigns");
    }
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  const isSuccess = operationtype === "success";

  if (loading) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        <div className="flex flex-col items-center space-y-4">
          <Spinner className="w-8 h-8 text-muted-foreground" />
          <p className="text-muted-foreground text-sm">Processing...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-screen flex items-center justify-center">
      <div className="flex flex-col items-center space-y-4 text-center">
        {isSuccess ? (
          <CheckCircle className="w-12 h-12 text-success" />
        ) : (
          <XCircle className="w-12 h-12 text-muted-foreground" />
        )}

        <div>
          <h2 className="text-xl font-medium text-foreground mb-1">
            {isSuccess ? "Payment Successful" : "Payment Cancelled"}
          </h2>
          <p className="text-muted-foreground text-sm">
            {isSuccess
              ? "Redirecting to dashboard..."
              : "You can try again anytime"}
          </p>
        </div>

        <Button
          variant="neutral"
          className="mt-4"
          onClick={() =>
            (window.location.href = isSuccess
              ? "/dashboard/campaigns"
              : "/pricing")
          }
        >
          {isSuccess ? "Continue" : "Back to Pricing"}
        </Button>
      </div>
    </div>
  );
}
